/** @format */

export const LOGIN = "LOGIN";
export const LOADING = "LOADING";
export const LOGOUT = "LOGOUT";
export const VALIDATED_USER_ID = "VALIDATED_USER_ID";
